import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { useState, useEffect } from 'react';
import { LoadingText,MapContainerStyle } from '../../../../styles/MerchantSignupMap';
interface Location {
  lat: number;
  lng: number;
}

interface MapContainerProps {
  location?: Location;
  className?: string;
}

const defaultLocation: Location = {
  lat: 1.279884763584536,
  lng: 103.84660123134285,
};

const MapContainer: React.FC<MapContainerProps> = ({ location, className }) => {
  const [loc, setLoc] = useState<Location>(location || defaultLocation);

  useEffect(() => {
    if (location) {
      setLoc(location);
    }
  }, [location]);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_API_KEY || "",
  });

  if (!isLoaded) return <LoadingText>Loading Map...</LoadingText>;

  return (
    <MapContainerStyle className={className}>
      <GoogleMap
        mapContainerStyle={{ height: '100%', width: '100%' }}
        zoom={location ? 19 : 13}
        center={loc}
        options={{
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
        }}
      >
        <Marker position={loc} />
      </GoogleMap>
    </MapContainerStyle>
  );
};

export default MapContainer;
